import http from '@/http'

export async function getGlobalPartPricing (id: number): Promise<any> {
  const { data } = await http.get(`admin/parts/${id}/pricing`)
  return data?.base ?? {}
}